module.exports = __webpack_public_path__ + "img/patient-record-mobile-fr.92e24af7.jpg";